<template>
	<side-window :tabs="tabs" :active="active" class="employee" title="Medarbejder" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<photo-view @remove="removePhoto" ref="photo" :url="entity._links.photo.href" name="photo" />
					<string-view label="Nr" v-model="entity.number" />
					<string-view label="Navn" v-model="entity.name" />
					<string-view label="Initialer" v-model="entity.initials" />
					<string-view :optional="true" label="Titel" v-model="entity.title" />
					<string-view :optional="true" label="Rating (1-5)" v-model="entity.rating" />
				</div>
				<div v-show="active == 'details'">
					<contact-select-view v-model="entity" label="Vikar fra" :optional="true" @select="contactSelect" />
					<select-view label="Status" v-model="entity.active" :options="[
						{
							value: true,
							label: 'Aktiv'
						},
						{
							value: false,
							label: 'Inaktiv'
						}
					]"/>
				</div>
				<div v-show="active == 'details'">
					<string-view label="Afsender" :optional="true" v-model="entity.email_user" :suffix="'@' + customer.domain" />
					<string-view label="Telefon" v-model="entity.phone" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="E-mail" v-model="entity.email" />
					<string-view :optional="this.id ? true : false" :password="true" label="Adgangskode" v-model="entity.password" />
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Omkostning pr time (privat)" v-model="entity.cost" />
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Omkostning pr time (erhverv)" v-model="entity.cost_biz" />
				</div>

				<div v-for="(role, i) in roles" v-bind:key="'roles' + i" v-show="active == 'roles'">
					<div class="side-window__heading">
						{{ role.label }}
						<switch-view v-model="entity.roles[role.name].enabled" />
					</div>
					<div v-show="entity.roles[role.name].enabled">
						<div v-for="(prop, j) in role.props" v-bind:key="j" class="side-window__heading small">
							{{ prop.label }}
							<switch-view v-model="entity.roles[role.name]['props'][prop.name]" />
						</div>
					</div>
				</div>

				<div v-for="(priv, i) in _privilegesFiltered" v-bind:key="'privileges' + i" v-show="active == 'privileges'">
					<div class="side-window__heading">
						{{ priv.label }}
						<switch-view v-model="entity.privileges[priv.name]" />
					</div>
					<div v-show="entity.privileges[priv.name]">
						<div v-for="(child, j) in priv.childrenFiltered" v-bind:key="j">
							<div class="side-window__heading small">
								{{ child.label }}
								<switch-view v-model="entity.privileges[child.name]" />
							</div>
							<div v-show="entity.privileges[child.name]">
								<div v-for="(child2, k) in child.children" v-bind:key="k">
									<div class="side-window__heading small">
										- {{ child2.label }}
										<switch-view v-model="entity.privileges[child2.name]" />
									</div>
									<div v-show="entity.privileges[child2.name]">
										<div v-for="(child3, i) in child2.children" v-bind:key="i">
											<div class="side-window__heading small">
												- - {{ child3.label }}
												<switch-view v-model="entity.privileges[child3.name]" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-for="(dept, i) in departments" v-bind:key="'departments' + i" v-show="active == 'departments'">
					<div class="side-window__heading">
						{{ dept.label }}
						<switch-view :value="_departments.includes(dept.id)" @input="departmentsInput($event, dept)" />
					</div>
				</div>

				<div v-for="(dept, i) in vehicles" v-bind:key="'vehicles' + i" v-show="active == 'vehicles'">
					<div class="side-window__heading">
						{{ dept.name }}
						<switch-view :value="_vehicles.includes(dept.id)" @input="vehiclesInput($event, dept.id)" />
					</div>
				</div>

				<div v-show="active == 'working_hours'">
					<div class="side-window__heading">
						Timebetalt
						<switch-view v-model="entity.hourly_paid" />
					</div>
				</div>

				<div v-for="(day, i) in entity.working_hours" v-bind:key="'week' + i" v-show="active == 'working_hours'">
					<div class="side-window__heading">
						{{ week[i] }}
						<switch-view v-model="entity.working_hours[i].active" />
					</div>
					<form-line-layout v-show="entity.working_hours[i].active">
						<string-view :optional="true" label="Fra" v-model="entity.working_hours[i].from" />
						<string-view :optional="true" label="Til" v-model="entity.working_hours[i].to" />
					</form-line-layout>
				</div>

				<date-picker-view v-model="date" v-show="active == 'stamps'" @change="updateStamps" class="date-picker" :style="{
						width: '100%'
					}" />
				<div class="history" v-show="active == 'stamps'">
					<div v-for="(stamp, idx) in stamps" :key="idx" @contextmenu.prevent="context($event, stamp)">
						<div class="grid">
							<div>{{ stamp.type == 'in' ? (stamp.task_id ? 'Check ind' : 'Stempel ind') : (stamp.task_id ? 'Check ud' : 'Stempel ud') }}</div>
							<div style="text-align: right;">{{ stamp.stamp | extractTime }}</div>
						</div>
						<div v-if="stamp.task_id !== null" class="middle">#{{ stamp.num | integer }} {{ stamp.name }}</div>
					</div>
				</div>
				<div v-show="active == 'stamps'">
					<div class="btn" @click="open_stamp(null)">Opret</div>
				</div>
				<div v-show="active == 'employments'">
					<employments-view v-model="entity._embedded.employments" />
				</div>

				<div v-show="active == 'reports'">
					<div class="side-window__heading">
						Daglige salgstal (e-mail)
						<switch-view v-model="entity.reports.sales" />
					</div>
					<div class="side-window__heading">
						Daglige aktivitetstal (e-mail)
						<switch-view v-model="entity.reports.activity" />
					</div>
					<div class="side-window__heading">
						Bekræftelse ved sendt SMS (SMS)
						<switch-view v-model="entity.reports.sms" />
					</div>
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import ContactSelectView from '../views/ContactSelectView';
	import ContextPopupView from '../views/ContextPopupView'

	import StampWindow from '../windows/StampWindow'
	import EmploymentsView from '../views/EmploymentsView'

	const employment = {
		from: null,
		to: null,
	};

	export default {
		data: function () {
			return {
				date: (new Date()).format('Y-m-d'),
				stamps: [],
				entity: {
					rating: '',
					number: null,
					id: null,
					name: null,
					initials: null,
					email: null,
					cost: null,
					cost_biz: null,
					phone: null,
					title: null,
					department_id: null,
					signature: null,
					username: null,
					password: null,
					roles: {},
					privileges: {},
					active: true,
					contact_id: null,
					email_user: null,
					hourly_paid: true,
					working_hours: {
						mon: null,
						tue: null,
						wed: null,
						thu: null,
						fri: null,
						sat: null,
						sun: null
					},
					reports: {
						activity: false,
						sales: false,
						sms: false,
					},
					_embedded: {
						department: {},
						departments: [],
						vehicles: [],
						employments: []
					},
					_links: {
						photo: {
							href: null
						}
					}
				},
				active: 'details',
				roles: [],
				privileges: [],
				departments: [],
				vehicles: [],
				week: {
					mon: 'Mandag',
					tue: 'Tirsdag',
					wed: 'Onsdag',
					thu: 'Torsdag',
					fri: 'Fredag',
					sat: 'Lørdag',
					sun: 'Søndag'
				},
				customer: {
					domain: ''
				}
			};
		},
		components: {
			'ContactSelectView': ContactSelectView,
			EmploymentsView,
		},
		watch: {
			entity: {
				deep: true,
				handler: function () {
					
				}
			}
		},
		computed: {
			_privilegesFiltered() {
				var r = [];

				for (var i = 0; i < this.privileges.length; ++i) {
					var priv = this.privileges[i];

					if (!priv.module || this.$store.state.employee._embedded.customer.modules.includes(priv.module)) {
						// Filter children
						var cf = [];

						for (var j = 0; j < priv.children.length; ++j) {
							var c = priv.children[j];

							if (!c.module || this.$store.state.employee._embedded.customer.modules.includes(c.module)) {
								cf.push(c);
							}
						}

						priv.childrenFiltered = cf;

						r.push(priv);
					}
				}

				return r;
			},
			_departments() {
				var r = [];
				for (var i = 0; i < this.entity._embedded.departments.length; ++i) {
					r.push(this.entity._embedded.departments[i].id);
				}

				return r;
			},
			_vehicles() {
				var r = [];
				for (var i = 0; i < this.entity._embedded.vehicles.length; ++i) {
					r.push(this.entity._embedded.vehicles[i]);
				}

				return r;
			},
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			_privileges() {
				return this.getPrivileges(this.privileges);
			},
			tabs: function () {
				var tabs = [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'roles',
						label: 'Roller'
					}
				];

				if (this.$store.state.employee && this.$store.state.employee.privileges && this.$store.state.employee.privileges.admin) {
					tabs.push({
						name: 'privileges',
						label: 'Adgang'
					});

					tabs.push({
						name: 'departments',
						label: 'Afd'
					});
				}

				return tabs.concat([
					{
						name: 'vehicles',
						label: 'Køretøjer'
					},
					{
						name: 'working_hours',
						label: 'Tider'
					},
					{
						name: 'employments',
						label: 'Ansættelser'
					},
					{
						name: 'reports',
						label: 'Rapporter'
					}
				]);
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			async open_stamp(stamp) {
				
				const self = this;

				var ent = {
					employee_id: this.id
				};

				if (stamp !== null) {
					// Load stamp
					ent = (await self.axios.get(`/stamps/${stamp.id}/`)).data;
				}

				

				this.$store.state.windowStack.push(StampWindow, {
					ent: ent,
					async submit(ent, a, b) {
						

						if (ent.id) {
							// Update
							await self.axios.put(`/stamps/${ent.id}/`, ent);
						} else {
							// New
							await self.axios.post(`/stamps/`, ent);
						}

						self.$store.state.windowStack.pop();
						self.updateStamps(self.date);
					}
				});
			},
			context(event, stamp) {
				
				const self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event,
					align: 'left',
					actions: [
						{
							label: 'Rediger stempel',
							action: function () {
								self.open_stamp(stamp);
							}
						},
						{
							label: 'Slet stempel',
							action: async function () {
								if (confirm("Er du sikker?")) {
									//await ReservationModel.delete(self.axios, track.reservation_id);
									await self.axios.delete(`/stamps/${stamp.id}/`);
									self.updateStamps(self.date);
								}
							}
						}
					]
				});
			},
			async updateStamps(date) {
				
				this.date = date;
				this.stamps = (await this.axios.get(`/employees/${this.id}/stamps/?date=${this.date}`)).data;
			},
			getPrivileges(arr) {
				var r = {};

				for (var i = 0; i < arr.length; ++i) {
					

					r[arr[i].name] = arr[i].default;

					if (arr[i].children.length > 0) {
						r = r.concat(this.getPrivileges(arr[i].children));
					}
				}

				return r;
			},
			contactSelect(obj) {
				

				/*this.entity.name = obj.name;
				this.entity.email = obj.email;
				this.entity.phone = obj.phone;*/
			},
			departmentsInput(value, dept) {
				if (value) {
					this.entity._embedded.departments.push(dept);
				} else { 
					this.entity._embedded.departments = this.entity._embedded.departments.filter(function (val) {
						 return val.id != dept.id;
					})
				}
			},
			vehiclesInput(value, dept) {
				if (value) {
					this.entity._embedded.vehicles.push(dept);
				} else {
					this.entity._embedded.vehicles = this.entity._embedded.vehicles.filter(function (val) {
						 return val != dept;
					})
				}
			},
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			removePhoto() {
				this.entity.photo = this.photoUrl + '?' + (new Date()).getTime();
			},
			create() {
				var self = this;

				
				

				this.axios
					.post('/employees/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							self.$refs.photo.update('/employees/' + r.data.id + '/photo/', function () {
								self.onCreate(r.data);
								self.onChange(r.data);
								self.$store.state.windowStack.pop();
							});
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				var self = this;

				this.axios
					.put('/employees/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							self.$refs.photo.update('/employees/' + self.id + '/photo/', function () {
								self.onCreate(r.data);
								self.onChange(r.data);
								self.$store.state.windowStack.pop();
							});
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		created() {
			
		},
		mounted: function() {
			

			var self = this;

			for (var day in this.week) {
				self.entity.working_hours[day] = {
					active: true,
					from: '05:00',
					to: '23:00'
				};
			}

			

			if (this.id) {
				this.axios
					.get('/employees/' + this.id + '/')
					.then(function (r) {
						self.entity = { ...self.entity, ...r.data };
						self.entity.roles = {...self._roles, ...self.entity.roles};
						self.entity.privileges = {...self._privileges, ...self.entity.privileges};

						// Working hours
						for (day in self.week) {
							if (!self.entity.working_hours[day]) {
								self.entity.working_hours[day] = {
									active: false,
									from: '09:00',
									to: '17:00'
								};
							}
						}

						// Vehicles
					
					});
			}

			this.axios
				.get('/us/employees/roles/')
				.then(function (r) {
					self.roles = r.data._items;
					self.entity.roles = {...self._roles, ...self.entity.roles};
				});

			this.axios
				.get('/employees/privileges/')
				.then(function (r) {
					self.privileges = r.data._items;
					self.entity.privileges = {...self._privileges, ...self.entity.privileges};
				});

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					self.vehicles = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/us/')
				.then(function (r) {
					self.customer = r.data;
					//self.departments = r.data._items;
				});
		}
	}
</script>

<style lang="scss">
	.history {
		
	}

	.history > div {
		padding: 20px;
		border-bottom: 1px solid #333;
		overflow: hidden;
	}

	.history > div > div.grid {
		display: grid;
		grid-template-columns: 1fr 2fr;
	}

	.history > div > div.middle {
		padding: 10px 0 0 0;
		font-size: 12px;
		overflow: hidden;
	}



	.history > div > div.bottom > div {
		text-align: center;
		overflow: hidden;
	}

	.history > div > div.middle > a {
		color: #f7223f;
	}

	.history > div > div.bottom > div > span {
		display: block;
		text-align: center;
		font-size: 12px;
		color: #ccc;
		padding-bottom: 10px;
	}

	.btn {
		background-color: #202127;
		line-height: 40px;
		text-align: center;
		margin-bottom: 10px;
		cursor: pointer;
	}
</style>
